import {BrowserModule, Title} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {APP_BASE_HREF, CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {GridsterModule} from 'angular-gridster2';
import {DynamicModule} from 'ng-dynamic-component';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from '../app.component';
import {WidgetBarComponent} from '../components/widget-bar/widget-bar.component';
import {ConfigServiceProvider} from '../services/config/config.service.provider';
import {GridComponent} from '../components/grid/grid.component';
import {WidgetModule} from './widget.module';
import {ViewModule} from './view.module';
import {MatDialogModule} from '@angular/material/dialog';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../../environments/environment';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {PrivacyDialogComponent} from '../components/privacy-dialog/privacy-dialog.component';
import {PrivacySnackbarComponent} from '../components/privacy-snackbar/privacy-snackbar.component';

@NgModule({
  declarations: [
    AppComponent,
    WidgetBarComponent,
    GridComponent,
    PrivacyDialogComponent,
    PrivacySnackbarComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    GridsterModule,
    HttpClientModule,
    FormsModule,
    WidgetModule,
    DynamicModule,
    ViewModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatButtonModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    ConfigServiceProvider,
    Title,
    {provide: APP_BASE_HREF, useValue: './'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
